__turbopack_context__.v({
  "card": "nQDS8a_card",
  "currentCard": "nQDS8a_currentCard",
  "preview": "nQDS8a_preview",
  "rotationProgress": "nQDS8a_rotationProgress",
  "templateName": "nQDS8a_templateName",
});
